/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5.2498 11.6893.22 16.719c-.0002.0003.0002-.0002 0 0-.293.2929-.2935.7684-.0006 1.0613a.75.75 0 0 0 1.0606 0l3.2197-3.2196V20.25c0 2.0711 1.679 3.75 3.7501 3.75H20.25c2.071 0 3.75-1.6789 3.75-3.75v-9.9569a2.2501 2.2501 0 0 0-.5211-1.44L16.7758.8097A2.2501 2.2501 0 0 0 15.0473 0H8.2498c-2.0711 0-3.75 1.679-3.75 3.75v2.5313a.75.75 0 0 0 1.5 0V3.75c0-1.2426 1.0073-2.25 2.25-2.25h6.7501v8.1a.9.9 0 0 0 .9.9H22.5v9.75c0 1.2426-1.0074 2.25-2.25 2.25H8.2498c-1.2427 0-2.25-1.0074-2.25-2.25v-5.6893l3.2197 3.2196a.75.75 0 0 0 1.0607-1.0606l-5.0304-5.0304ZM21.6487 9h-5.1488V2.8215L21.6487 9Z"
    clipRule="evenodd"
  />,
  'File'
);
